import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';

// Create a theme context
const ThemeContext = createContext();

// Basic MUI theme configurations
const lightThemeMui = createTheme({
  palette: {
    mode: 'light',
    // TODO: Further customize to match Grafana & our CSS variables
    // Example: primary: { main: 'var(--color-primary)' }
  },
  // TODO: Customize typography, spacing, components etc.
});

const darkThemeMui = createTheme({
  palette: {
    mode: 'dark',
    // TODO: Further customize to match Grafana & our CSS variables
  },
});

// Theme options
export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light'
};

export function ThemeProvider({ children }) {
  // Initialize theme from localStorage or default to dark
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || THEMES.DARK;
  });

  // Update the theme attribute on the document when theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    setTheme(prevTheme => 
      prevTheme === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK
    );
  };

  // Set a specific theme
  const setThemeValue = (newTheme) => {
    if (Object.values(THEMES).includes(newTheme)) {
      setTheme(newTheme);
    }
  };

  return (
    <ThemeContext.Provider value={{ 
      theme, 
      toggleTheme,
      setTheme: setThemeValue,
      isDarkTheme: theme === THEMES.DARK,
      isLightTheme: theme === THEMES.LIGHT
    }}>
      <MuiThemeProvider theme={theme === THEMES.LIGHT ? lightThemeMui : darkThemeMui}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
